import { render, staticRenderFns } from "./CompSelect.vue?vue&type=template&id=28707eb4&"
import script from "./CompSelect.vue?vue&type=script&lang=ts&"
export * from "./CompSelect.vue?vue&type=script&lang=ts&"
import style0 from "./CompSelect.vue?vue&type=style&index=0&id=28707eb4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports